// utils/dates.ts
const hasTz = (s: string) => /[zZ]|[+-]\d{2}:?\d{2}$/.test(s);

const parseUtc = (input?: string | number | Date) => {
  if (!input) return null;
  if (input instanceof Date) return input;
  if (typeof input === "number") {
    // seconds vs ms
    return new Date(input < 1e12 ? input * 1000 : input);
  }
  const s = input.trim();
  // If no offset present, assume server meant UTC
  return new Date(hasTz(s) ? s : `${s}Z`);
};

export const formatDateLocal = (
  input?: string | number | Date,
  options: Intl.DateTimeFormatOptions = {}
) => {
  const d = parseUtc(input);
  if (!d || Number.isNaN(d.getTime())) return "";
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // explicit
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone,
    ...options,
  }).format(d);
};